/**
 * F.lli GalCoS — comportamenti di marca.
 * Nessuna dipendenza. Sicuro da eseguire più volte (idempotente).
 */
(() => {
  const REVEAL_SELECTOR = '.galcos-reveal:not([data-galcos-revealed])';

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Rivela gli elementi quando entrano nel viewport. */
  function initReveal(root = document) {
    const targets = root.querySelectorAll(REVEAL_SELECTOR);
    if (!targets.length) return;

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      targets.forEach((el) => {
        el.dataset.galcosRevealed = 'true';
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    targets.forEach((el) => {
      el.dataset.galcosRevealed = 'true';
      observer.observe(el);
    });
  }

  /**
   * Carosello a scroll-snap nativo: i pulsanti spostano di una "pagina".
   * Lo scroll con dito/trackpad funziona anche senza JS.
   */
  function initCarousels(root = document) {
    root.querySelectorAll('[data-galcos-carousel]:not([data-galcos-ready])').forEach((carousel) => {
      carousel.dataset.galcosReady = 'true';

      const track = carousel.querySelector('[data-galcos-track]');
      const prev = carousel.querySelector('[data-galcos-prev]');
      const next = carousel.querySelector('[data-galcos-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const first = track.firstElementChild;
        if (!first) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const scrollBy = (direction) => {
        track.scrollBy({
          left: step() * direction,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        });
      };

      const syncButtons = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        carousel.classList.toggle('is-static', max <= 0);
      };

      prev.addEventListener('click', () => scrollBy(-1));
      next.addEventListener('click', () => scrollBy(1));
      track.addEventListener('scroll', syncButtons, { passive: true });
      window.addEventListener('resize', syncButtons, { passive: true });
      syncButtons();
    });
  }

  function init(root = document) {
    initReveal(root);
    initCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Editor del tema e navigazioni con view transition.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('page:loaded', () => init());
})();
